import ClaimGeneralSharedFields from '@rd-web-markets/shared/dist/claim/editForm/ClaimGeneralSharedFields';
import React from 'react';
const ClaimGeneralEditMarketFields = props => /*#__PURE__*/React.createElement(ClaimGeneralSharedFields, props);
export default ClaimGeneralEditMarketFields;